import { FULL_NAME } from "helpers/common";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import MessagingInterface from "components/shared/ChatComponent/MessagingInterface";
import { initiateConversation } from "store/services/clientMessagingService";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Col, Row } from "react-bootstrap";

const MessagingTab = ({
  dispatch,
  clientDetails,
  loadingClientDetails,
  userInfo,
  conversationList
}) => {
  const { clientId } = useParams();
  const [isLoading, setLoading] = useState(false);

  const conversation = useMemo(() => {
    if(!conversationList?.length) {
      return null;
    }

    return conversationList.find(conversation => conversation.client_id === Number(clientId));
  }, [conversationList])

  useEffect(() => {
    if(!clientId) {
      return;
    }

    initiateClientConversation(clientId);
  }, [clientId]);

  const initiateClientConversation = async (clientId) => {
    try {
      setLoading(true);
      await dispatch(initiateConversation(clientId));
    } catch(err) {
      console.error("Failed to initialze conversation", err);
    } finally {
      setLoading(false);
    }
  }

  let clientFullName = () => {
    return FULL_NAME(clientDetails.first_name, clientDetails.last_name);
  }

  return (
    <>
      <div className="top d-flex align-items-start justify-content-between gap-10">
        {(!loadingClientDetails && clientDetails) &&
          <div className="left">
            <h6 className="m-0 fw-bold">
              Chat with {clientFullName()}
            </h6>
            <p className="m-0">
              Ask questions or share updates with {clientFullName()}.
            </p>
          </div>
        }
        <div className="right">
        </div>
      </div>
      <div className="CardBody py-3">
        <Row>
        <Col lg={8} className="p-0 border">
          <div style={{ minHeight: "500px", position: "relative" }}>
          {isLoading ? (
            <LoadingIndicator
              inline={true}
              size={10}
            />
          ):conversation ? (
              <>
                <div className="p-3 d-flex justify-content-between align-items-center border-bottom bg-light shadow-sm">
                  <div>
                    <h6 className="fw-sbold theme-clr">{clientFullName()}</h6>
                  </div>
                  {/* <Badge bg={isConnected ? "success" : "secondary"}>
                    {isConnected ? "Active" : "Inactive"}
                  </Badge> */}
                </div>
                <MessagingInterface
                  userId={userInfo?.id}
                  clientId={clientId}
                  conversationId={conversation?.conversation_id}
                  clientName={clientFullName()}
                />
              </>
            ) : (
              <p>Failed to initialize chat</p>
            )}
          </div>
        </Col>
        </Row>
        
      </div>
    </>
  );
};

const mapStateToPros = (state) => {

  return {
    clientDetails: state.Client.client.details,
    loadingClientDetails: state.Client.loadingClientDetails,
    accountSettingDetails: state?.AccountSetting?.accountSettingDetail_,
    userInfo: state.Profile.user,
    conversationList: state.ClientMessaging.conversationList,
  };
};


function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(MessagingTab);